import { EmbedProvider } from "../contexts/EmbedContext";
import { PaymentErrorView } from "@fm/ui";

interface PaymentErrorContainerProps {
  error: string;
  apiKey: string;
  fleetId: string;
  stripePublishableKey: string;
  theme?: "light" | "dark";
  onRetry?: () => void;
  /**
   * @deprecated No longer rendered: the page has one "Try again" action.
   * Kept so the registered web component's `onGoBack` event still type-checks.
   */
  onGoBack?: () => void;
  /** Fleet phone for the "Call the fleet" link. */
  phone?: string | null;
}

function PaymentErrorContainerInner({
  error,
  onRetry,
  phone,
}: Omit<
  PaymentErrorContainerProps,
  "apiKey" | "fleetId" | "stripePublishableKey" | "theme" | "onGoBack"
>) {
  return <PaymentErrorView error={error} onRetry={onRetry} phone={phone} />;
}

export function PaymentErrorContainer(props: PaymentErrorContainerProps) {
  return (
    <EmbedProvider
      apiKey={props.apiKey}
      fleetId={props.fleetId}
      stripePublishableKey={props.stripePublishableKey}
      theme={props.theme}
    >
      <PaymentErrorContainerInner {...props} />
    </EmbedProvider>
  );
}
